import {useEffect, useRef, useState} from 'react';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {TagRegularDiagonalIcon} from 'shells/icon/svg/tag-regular-diagonal-icon';
import {Illustration} from 'shells/illustrations/illustration';

import {appHistory} from '../../../../history';

import {OnboardingModuleCardContent} from '../onboarding-module/onboarding-module-card-content';

import {OFFER_PARAM, QUOTES_PROMO_PARAM_VALUE} from './consts';
import {QuotesPromoModal} from './quotes-promo-modal';

interface Props {
    shouldShow: boolean;
    isLoading: boolean;
    refetchSetting: () => void;
}

export function QuotesPromoBanner(props: Props) {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const didAutoOpen = useRef<boolean>(false);

    useEffect(() => {
        if (props.isLoading || didAutoOpen.current) return;

        const params = new URLSearchParams(appHistory.location.search);
        if (params.get(OFFER_PARAM) !== QUOTES_PROMO_PARAM_VALUE) return;

        params.delete(OFFER_PARAM);
        appHistory.replace({...appHistory.location, search: params.toString()});

        if (props.shouldShow) {
            didAutoOpen.current = true;
            setIsModalOpen(true);
        }
    }, [props.isLoading, props.shouldShow]);

    if (!props.shouldShow && !isModalOpen) {
        return null;
    }

    return (
        <>
            {props.shouldShow && (
                <Card hasBorder={true} borderRadius={8} fitHeight={true}>
                    <OnboardingModuleCardContent
                        illustration={<Illustration src='quotes-and-invoices-free-offer' />}
                        title='Quotes & Invoices: free for 3 months'
                        description='Create, send and track sales documents directly from Nutshell'
                        rightSection={
                            <Button
                                variant='primary'
                                size='big'
                                onClick={() => setIsModalOpen(true)}
                                icon={TagRegularDiagonalIcon}
                            >
                                Claim offer
                            </Button>
                        }
                    />
                </Card>
            )}
            {isModalOpen && (
                <QuotesPromoModal
                    onClose={() => setIsModalOpen(false)}
                    onActivated={props.refetchSetting}
                />
            )}
        </>
    );
}
